export default {
  getAll: {
    method: 'post',
    url: '/company/speed-assumptions/list'
  },
  create: {
    method: 'post',
    url: '/company/speed-assumptions'
  },
  update: {
    method: 'put',
    url: '/company/speed-assumptions/update'
  },
  delete: {
    method: 'delete',
    url: '/company/speed-assumptions'
  }
}
